<template>
    <div>
        <base-table
            hide-default-footer
            v-bind="$attrs"
            v-on="$listeners"
            :headers="processedHeaders"
            :items="processedItems"
            :options="options"
            @click:row="onRowItemClick">
            <template v-slot:[`item.createdAt`]="{ item }">
                <span>
                    {{ $util.getDDMMYYYYDateFormat(new Date(item.createdAt) + (60 * 420 * 1000)) }}
                </span>

                <span class="grey--text">
                    {{ $util.getHHSSDateFormat(new Date(item.createdAt) + (60 * 420 * 1000)) }}
                </span>
            </template>
        </base-table>
    </div>
</template>

<script>
import BaseTable from '@/components/tables/BaseTable'
import { TableMixinFactory } from '@/mixins/TableMixin'

export default {
    name: 'WalletTable',

    components: {
        BaseTable
    },

    mixins: [
        TableMixinFactory()
    ],

    data () {
        return {
            headers: [
                {
                    text: this.$t('andamandaPay.pocketTable.header.pocketId'),
                    value: 'CustomerID',
                    sortable: false
                },
                {
                    text: this.$t('andamandaPay.pocketTable.header.firstName'),
                    value: 'name',
                    sortable: false
                },
                {
                    text: this.$t('andamandaPay.pocketTable.header.lastName'),
                    value: 'lastname',
                    sortable: false
                },
                {
                    text: this.$t('andamandaPay.pocketTable.header.activationDate'),
                    value: 'createdAt'
                }
            ]
        }
    },

    methods: {
        onRowItemClick (item) {
            this.$emit('viewDetails', item)
        }
    }
}
</script>

<style lang="scss" scoped></style>
